import React from 'react';
/** Services Import */
import Global from '../../Services/Common/Global';
import Commons from '../../Services/Common/Common';
import Dialog from '../../Services/Common/Dialog';
import IndexedDb from '../../Services/IndexedDb/IndexedDb';
/** Components Import */
import Sm10040View from '../../Views/Sales/SM10040';
import Snackbar from '../../Components/Snackbar';

function SM10040(props) {
    const [snackbars, setSnackbars] = React.useState({
        toggle: false,
        type: '',
        message: '',
    });
    const today = new Date();
    const monthAgo = new Date(today);
    const [inputs, setInputs] = React.useState({
        endDate: new Date(),
        startDate: new Date(today.setMonth(today.getMonth() - 3)),
        searchInput: '',
        comboList: [],
        custList: [],
        delivOrderNo: '',
        custCd: '',
        custNm: '',
        delivOrderQty: 0,
        remark: '',
    });
    const [checkInputs, setCheckInputs] = React.useState({
        delivOrderNo: '',
        itemCd: '',
        custCd: '',
        delivOrderDate: new Date(),
        itemQty: '',
        whCd: 'WH_MM_01',
    });
    //왼쪽 그리드 +버튼 안 파라미터
    const [paramsInputs, setParamsInputs] = React.useState({
        itemCd: '',
        custCd: '',
    });
    const [lanData, setLanData] = React.useState([]);
    const [rowData, setRowData] = React.useState([]);
    const [rowData1, setRowData1] = React.useState([]);
    const [rowData2, setRowData2] = React.useState([]);
    const [orderData, setOrderData] = React.useState([]);
    const [stockData, setStockData] = React.useState([]);
    const [cancleStockData, setCancleStockData] = React.useState([]);
    const [changedRowData, setChangedRowData] = React.useState([]);
    const [selectedRowData, setSelectedRowData] = React.useState([]);
    const [selectedRowData1, setSelectedRowData1] = React.useState([]);
    const [selectedRowData2, setSelectedRowData2] = React.useState([]);
    const [selectedModalData, setSelectedModalData] = React.useState([]);
    const [selectedModalData1, setSelectedModalData1] = React.useState([]);
    const [selectedModalData2, setSelectedModalData2] = React.useState([]);

    React.useEffect(() => {
        window.addEventListener('error', (e) => {
            if (e.message === 'ResizeObserver loop limit exceeded') {
                const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client- overlay-div');
                const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none');
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none');
                }
            }
        });
        Init();
        GetCustList();
    }, []);

    // React.useEffect(() => {
    //   const autoSizeAll = (skipHeader) => {
    //     const allColumnIds = [];
    //     gridColumnApi.getColumns().forEach((column) => {
    //       allColumnIds.push(column.getId());
    //     });
    //     gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    //   };
    //   autoSizeAll(true);
    // }, []);

    const GetCustList = async () => {
        let getComboData = [];
        try {
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetCustList, {
                plantCd: 'string',
                value: 'string',
            }).then((result) => {
                let data = result.data;
                for (let i = 0; i < data.length; i++) {
                    getComboData.push({
                        id: data[i].custCd,
                        label: data[i].custNm,
                    });
                }
                setInputs({
                    ...inputs,
                    custList: [...getComboData],
                });
                // inputs.custList = getComboData;
            });
        } catch (e) {
            if (e.response.status === 401) {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: '로그인 정보가 만료되었습니다.',
                });
            } else {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: e.message,
                });
            }
        } finally {
        }
    };
    //왼쪽 그리드 조회(출하지시)
    const Init = async (_type = null) => {
        Dialog.ProgressBar(true);
        let getLanData = [];
        let getRowData = [];
        let getComboData = [];
        try {
            setInputs({
                ...inputs,
                delivOrderNo: '',
                custCd: '',
                custNm: '',
            });
            setRowData1([]);
            setRowData2([]);

            await IndexedDb.GetAllDb('LanguageList').then((result) => {
                if (result.length > 0) {
                    getLanData = result.filter((f) => f.lanType !== 'MENU');
                }
            });
            setLanData(getLanData);

            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.GetSalesDelivOrders, {
                startDate: inputs.startDate,
                endDate: inputs.endDate,
                delivOrderNo: inputs.searchInput ? inputs.searchInput : 'string',
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    if (getLanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: getLanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    }
                } else if (data.type === 'Error') {
                    if (getLanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: getLanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    }
                } else {
                    if (!_type) {
                        // setSnackbars({
                        //   toggle: true,
                        //   type: "info",
                        //   message: lanData.filter(
                        //     (f) => f.lanId === "Snack_Search" && f.lanType === "SNACK"
                        //   )[0].lanName,
                        // });
                    }
                    for (let i = 0; i < data.length; i++) {
                        getRowData.push({
                            delivOrderNo: data[i].delivOrderNo,
                            delivOrderDt: data[i].delivOrderDt
                                ? Commons.DateFormating(data[i].delivOrderDt.toString(), 2)
                                : '',
                            soDueDt: data[i].soDueDt ? Commons.DateFormating(data[i].soDueDt.toString(), 2) : '',
                            itemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                            custCd: data[i].custCd,
                            custNm: data[i].custNm,
                            stusNm: data[i].stusNm,
                            soNo: data[i].soNo,
                            delivOrderQty: data[i].delivOrderQty,
                            itemQty: data[i].itemQty,
                            remark: data[i].remark,
                        });
                    }

                    setRowData(Commons.InsertNumber(getRowData));
                }
            });
        } catch (e) {
            if (e.response.status === 401) {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: '로그인 정보가 만료되었습니다.',
                });
            } else {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: e.message,
                });
            }
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    //거래처별 품목리스트
    const GetOrders = async () => {
        Dialog.ProgressBar(true);
        try {
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.GetSalesOrders, {
                custCd: paramsInputs.custCd == '' ? 'string' : paramsInputs.custCd,
                itemCd: paramsInputs.itemCd == '' ? 'string' : paramsInputs.itemCd,
            }).then((result) => {
                let data = result.data;
                let getData = [];
                if (data === '데이터가 없습니다.') {
                    if (lanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                        setOrderData([]);
                        setCheckInputs({ ...checkInputs, custCd: '' });
                    }
                } else if (data.type === 'Error') {
                    if (lanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    }
                } else {
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Viewed' && f.lanType === 'SNACK')[0].lanName,
                    });
                    for (let i = 0; i < data.length; i++) {
                        getData.push({
                            plantCd: data[i].plantCd,
                            soNo: data[i].soNo,
                            soDueDt: data[i].soDueDt ? Commons.DateFormating(data[i].soDueDt.toString(), 2) : '',
                            soDueNo: data[i].soDueNo,
                            custCd: data[i].custCd,
                            custNm: data[i].custNm,
                            itemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                            itemQty: data[i].itemQty,
                            stusCd: data[i].stusCd,
                            stusNm: data[i].stusNm,
                        });
                    }
                    setOrderData(Commons.InsertNumber(getData));
                    setCheckInputs({ ...checkInputs, custCd: '' });
                }
            });
        } catch (e) {
            if (e.response.status === 401) {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: '로그인 정보가 만료되었습니다.',
                });
            } else {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: e.message,
                });
            }
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    //오른쪽 그리드 조회(출하)
    const GetDelivOrderItems = async (_delivOrderNo, _itemCd) => {
        Dialog.ProgressBar(true);
        let getData = [];
        let delivQtyDev = 0;
        try {
            // if (!inputs.delivOrderNo) {
            //   return false;
            // }
            await Commons.Axios(
                'get',
                Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.GetSalesDelivOrderItems,
                {
                    delivorderNo: _delivOrderNo,
                    // itemCd: _itemCd,
                }
            ).then((result) => {
                let data = result.data;
                let compareQty = 0;

                if (data === '데이터가 없습니다.') {
                    setRowData2([]);
                    if (lanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    }
                } else if (data.type === 'Error') {
                    if (lanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    }
                } else {
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Viewed' && f.lanType === 'SNACK')[0].lanName,
                    });
                    for (let i = 0; i < data.length; i++) {
                        compareQty = compareQty + data[i].delivQty;
                        getData.push({
                            plantCd: data[i].plantCd,
                            delivOrderNo: data[i].delivOrderNo,
                            stusNm: data[i].stusNm,
                            delivDt: data[i].delivDt ? Commons.DateFormating(data[i].delivDt.toString(), 2) : '',
                            itemQty: data[i].itemQty,
                            delivOrderBackQty: data[i].delivOrderQty - compareQty,
                            delivOrderQty: data[i].delivOrderQty,
                            delivQty: data[i].delivQty,
                            stockQty: data[i].stockQty,
                            delivNo: data[i].delivNo,
                            // delivSeq: data[i].delivSeq,
                            lotNo: data[i].lotNo,
                            itemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                            remark: data[i].remark,
                            soDueDt: data[i].soDueDt,
                            soNo: data[i].soNo,
                            workQty: data[i].workQty,
                        });

                        delivQtyDev = delivQtyDev - data[i].delivQty;
                    }
                    setRowData2(Commons.InsertNumber(getData));
                }
            });
        } catch (e) {
            console.log(e);

            if (e.response.status === 401) {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: '로그인 정보가 만료되었습니다.',
                });
            } else {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: e.message,
                });
            }
        } finally {
            Dialog.ProgressBar(false);
        }
    };

    const ItemTied = () => {
        let getData = [];

        for (var i = 0; i < selectedModalData.length; i++) {
            // 데이터 수 만큼 반복
            var objPart = {};

            // var valid = getData.some(
            //   (item) => item.itemCd === selectedModalData[i].itemCd
            // ); // 증복값 확인

            // if (!valid) {
            // 중복값이 없으면
            getData.push({
                custCd: selectedModalData[i].custCd,
                custNm: selectedModalData[i].custNm,
                itemCd: selectedModalData[i].itemCd,
                itemNm: selectedModalData[i].itemNm,
                itemQty: selectedModalData[i].itemQty,
                delivOrderQty: selectedModalData[i].itemQty,
                plantCd: selectedModalData[i].plantCd,
                soNo: selectedModalData[i].soNo,
                stusCd: selectedModalData[i].stusCd,
                stusNm: selectedModalData[i].stusNm,
            });
            // }
        }
        setRowData1(Commons.InsertNumber(getData));
        // setInputs({
        //   ...inputs,
        //   custCd: getData[0].custCd,
        //   custNm: getData[0].custNm,
        // });
        // if (getData.length > 0) {
        //   setRowData1(Commons.InsertNumber(getData));
        //   setInputs({
        //     ...inputs,
        //     custCd: getData[0].custCd,
        //     custNm: getData[0].custNm,
        //   });
        // }
    };
    //왼쪽 그리드 저장(출하지시)
    const CreateDelivOrder = async () => {
        Dialog.ProgressBar(true);
        let userInfo = null;
        let updateData = [];
        try {
            if (inputs.delivOrderNo) {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: lanData.filter((f) => f.lanId === 'Snack_Shipped' && f.lanType === 'SNACK')[0].lanName,
                });
            }

            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            for (let i = 0; i < selectedModalData.length; i++) {
                for (let j = i + 1; j < selectedModalData.length; j++) {
                    if (selectedModalData[i].custNm != selectedModalData[j].custNm) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: '항목중에 다른 거래처가 있습니다.',
                        }); // 중복된 항목 발견
                        return false;
                    }
                }
            }
            for (let i = 0; i < selectedModalData.length; i++) {
                updateData.push({
                    delivOrderNo: selectedModalData[i].delivOrderNo,
                    itemCd: selectedModalData[i].itemCd,
                    custCd: selectedModalData[i].custCd,
                    delivOrderDt: Commons.DateStrChange(selectedModalData[i].delivOrderDt),
                    // delivDt: Commons.DateStrChange(selectedModalData[i].delivDt),
                    delivOrderQty: selectedModalData[i].itemQty,
                    // delivQty: selectedModalData[i].itemQty,
                    soNo: selectedModalData[i].soNo,
                    soDueDt: new Date(selectedModalData[i].soDueDt),
                    remark: inputs.remark,
                    writeNote: selectedModalData[i].remark,
                    retateId: userInfo.userId,
                    creurnYn: selectedModalData[i].returnYn,
                    createId: userInfo.userId,
                    createDate: Commons.DateStrChange(new Date()),
                    updateId: userInfo.userId,
                    updateDate: Commons.DateStrChange(new Date()),
                });
            }

            await Commons.Axios(
                'post1',
                Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.CreateDelivOrder,
                updateData
            ).then((result) => {
                let data = result.data;

                if (data !== 'Ok') {
                    setSnackbars({
                        toggle: true,
                        typ: 'error',
                        message: data,
                    });
                } else {
                    setInputs({
                        ...inputs,
                        endDate: new Date(),
                        searchInput: '',
                        delivOrderNo: '',
                        custCd: '',
                        custNm: '',
                    });
                    setRowData1([]);
                    Init();
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Save' && f.lanType === 'SNACK')[0].lanName,
                    });
                }
            });
        } catch (e) {
            if (e.response.status === 401) {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: '로그인 정보가 만료되었습니다.',
                });
            } else {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: e.message,
                });
            }
        } finally {
            Dialog.ProgressBar(false);
        }
    };

    const GetStockList = async () => {
        Dialog.ProgressBar(true);
        let getComboData = [];
        let getData = [];
        try {
            //창고콤보박스
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh, {
                whCd: 'string',
            }).then((result) => {
                let data = result.data;
                for (let i = 0; i < data.length; i++) {
                    getComboData.push({
                        value: data[i].value,
                        name: data[i].name,
                    });
                }
                inputs.comboList = getComboData.filter((e) => e.value.substring(0, 5) === 'WH_MM');
            });
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.GetStockList, {
                itemCd: selectedRowData[0].itemCd,
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    setStockData([]);
                    if (lanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    }
                } else if (data.type === 'Error') {
                    setStockData([]);
                    if (lanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    }
                } else {
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Viewed' && f.lanType === 'SNACK')[0].lanName,
                    });
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].stockQty > 0) {
                            getData.push({
                                itemCd: data[i].itemCd,
                                itemNm: data[i].itemNm,
                                lotNo: data[i].lotNo,
                                plantCd: data[i].plantCd,
                                stockQty: data[i].stockQty,
                                whCd: data[i].whCd,
                                soNo: data[i].soNo,
                                soDueDt: data[i].soDueDt,
                            });
                        }
                    }
                    if (getData.length === 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_OutofStock' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    } else {
                        setStockData(Commons.InsertNumber(getData));
                    }
                }
            });
        } catch (e) {
            console.log(e);
            if (e.response.status === 401) {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: '로그인 정보가 만료되었습니다.',
                });
            } else {
                setSnackbars({
                    toggle: true,
                    type: 'error',
                    message: e.message,
                });
            }
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    //출하
    const CreateDeliv = async (_delivDt) => {
        Dialog.ProgressBar(true);
        let userInfo = null;
        let pushData = [];
        try {
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            if (selectedModalData1.length <= 0) {
                return false;
            }

            for (let i = 0; i < selectedModalData1.length; i++) {
                pushData.push({
                    delivOrderNo: selectedRowData[0].delivOrderNo,
                    itemCd: selectedRowData[0].itemCd,
                    delivDt: _delivDt ? Commons.DateFormating(_delivDt.toString(), 2) : '',
                    lotNo: selectedModalData1[i].lotNo,
                    delivOrderQty: inputs.delivOrderQty ? inputs.delivOrderQty : 0,
                    delivQty: selectedModalData1[i].stockQty,
                    compareQty: selectedModalData1[i].stockQty,
                    soDueDt: selectedRowData[0].soDueDt,
                    soNo: selectedRowData[0].soNo,
                    remark: selectedRowData[0].remark,
                    returnYn: 'N',
                    createId: userInfo.userId,
                    createDate: Commons.DateStrChange(new Date()),
                    updateId: userInfo.userId,
                    updateDate: Commons.DateStrChange(new Date()),
                });
            }

            await Commons.Axios(
                'post1',
                Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.CreateDeliv,
                pushData
            ).then((result) => {
                let data = result.data;
                if (data === 'error') {
                    throw new Error('출하된 품목입니다.');
                }
                if (data === '데이터가 없습니다.') {
                } else if (data.type === 'Error') {
                    if (lanData.length != 0) {
                        throw new Error('품목 수량을 확인해주세요');
                    }
                } else {
                    Init();
                    GetDelivOrderItems(checkInputs.delivOrderNo, checkInputs.itemCd);
                    if (lanData.length != 0) {
                        setSnackbars({
                            toggle: true,
                            type: 'info',
                            message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                                .lanName,
                        });
                    }
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            setStockData([]);
            Dialog.ProgressBar(false);
        }
    };
    //출하취소 조회
    const CancleDelivModal = async (_itemCd, _delivOrderNo, _soDueDt) => {
        Dialog.ProgressBar(true);
        let getData = [];
        try {
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.CancleDelivModal, {
                itemCd: _itemCd,
                delivNo: selectedRowData2[0].delivNo,
                soDueDt: Commons.DateStrChange(new Date(_soDueDt)),
            }).then((result) => {
                let data = result.data;
                if (data === '데이터가 없습니다.') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_SelectItemCancel' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setCancleStockData([]);
                } else if (data.type === '데이터가 없습니다.') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_SelectItemCancel' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setCancleStockData([]);
                } else if (data.length === 0) {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_SelectItemCancel' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                    setCancleStockData([]);
                } else {
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Viewed' && f.lanType === 'SNACK')[0].lanName,
                    });
                    for (let i = 0; i < data.length; i++) {
                        getData.push({
                            lotNo: data[i].lotNo,
                            delivDt: data[i].delivDt ? Commons.DateFormating(data[i].delivDt.toString(), 2) : '',
                            delivOrderNo: data[i].delivOrderNo,
                            delivQty: data[i].delivQty,
                            itemCd: data[i].itemCd,
                            itemNm: data[i].itemNm,
                        });
                        setCancleStockData(Commons.InsertNumber(getData));
                    }
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    //출하취소
    const CancleDeliv = async () => {
        Dialog.ProgressBar(true);
        let pushData = [];
        let userInfo = null;
        try {
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });

            for (let i = 0; i < selectedModalData2.length; i++) {
                pushData.push({
                    plantCd: inputs.plantCd,
                    delivOrderNo: selectedRowData[0].delivOrderNo,
                    delivNo: selectedRowData2[0].delivNo,
                    itemCd: selectedModalData2[i].itemCd,
                    delivDt: new Date(selectedModalData2[i].delivDt)
                        ? Commons.DateFormating(new Date(selectedModalData2[i].delivDt).toString(), 2)
                        : '',
                    lotNo: selectedModalData2[i].lotNo,
                    delivOrderQty: 0,
                    delivQty: selectedModalData2[i].delivQty,
                    remark: 's',
                    returnYn: 'N',
                    createId: 'string',
                    createDate: Commons.DateStrChange(new Date()),
                    updateId: userInfo.userId,
                    updateDate: Commons.DateStrChange(new Date()),
                });
            }
            await Commons.Axios(
                'post1',
                Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.CancleDeliv,
                pushData
            ).then((result) => {
                let data = result.data;
                GetDelivOrderItems(checkInputs.delivOrderNo, checkInputs.itemCd);
                Init();
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };

    // 금액(한글) 변환
    function convertToKoreanNumber(num) {
        var numKor = new Array('', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구', '십'); // 숫자 문자
        var numKor2 = new Array('영', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구', '십'); // 소수점 이하 문자
        var danKor = new Array('', '십', '백', '천', '', '십', '백', '천', '', '십', '백', '천', '', '십', '백', '천'); // 만위 문자열
        var result = ''; // 숫자 결과
        var result2 = ''; // 소수점 결과

        if (num && !isNaN(num)) {
            // CASE: 금액이 공란/NULL/문자가 포함된 경우가 아닌 경우에만 처리
            var val = num.toString();
            var val2 = '';
            if (val.indexOf('.')) {
                // 소수점이 있을 경우, 소수점 뒷 부분은 따로 + result
                val2 = val.split('.')[1] == undefined ? '' : val.split('.')[1];
                val = val.split('.')[0];
            }

            for (var i = 0; i < val.length; i++) {
                var str = '';
                var num = numKor[val.charAt(val.length - (i + 1))];
                if (num != '') str += num + danKor[i]; // 숫자가 0인 경우 텍스트를 표현하지 않음
                switch (i) {
                    case 4:
                        str += '만';
                        break; // 4자리인 경우 '만'을 붙여줌 ex) 10000 -> 일만
                    case 8:
                        str += '억';
                        break; // 8자리인 경우 '억'을 붙여줌 ex) 100000000 -> 일억
                    case 12:
                        str += '조';
                        break; // 12자리인 경우 '조'를 붙여줌 ex) 1000000000000 -> 일조
                }

                result = str + result;
            }

            // Step. 불필요 단위 제거
            if (result.indexOf('억만') > 0) result = result.replace('억만', '억');
            if (result.indexOf('조만') > 0) result = result.replace('조만', '조');
            if (result.indexOf('조억') > 0) result = result.replace('조억', '조');

            // 소수점 이하가 있을경우
            if (val2 != '') {
                result = result + '점';

                // 소수점 변환
                for (var j = 0; j < val2.length; j++) {
                    var num2 = numKor2[val2.charAt(val2.length - (j + 1))];

                    result2 = num2 + result2;
                }
            }

            result = result + result2 + '원 정';
        }

        return result;
    }
    //인쇄
    const Print = async (_delivOrderNo, _delivOrderDt) => {
        let headerData = [];
        let tableData = [];
        let address;
        let purchaseDtlData = [];
        let totalAmt = [];
        let sumAmt = 0;
        //var ItemInfo = itemList.find(f => f.ItemCd == viewModel.DataItem.ItemCd);

        //address = "http://114.206.84.134:5540/SalesManagement/SalesManagement"; //http://localhost:65061/ 114.206.84.134:5540
        address = 'https://dongsungprintingmes.com:8082/SalesManagement/SalesManagement'; //http://localhost:65061/ 114.206.84.134:5540 https://dongsungprintingmes.com:8082

        if (rowData2.length === 0) {
            setSnackbars({
                toggle: true,
                type: 'info',
                message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0].lanName,
            });
        } else {
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.GetPrintData, {
                delivOrderNo: selectedRowData[0].delivOrderNo,
                delivOrderDt: selectedRowData[0].delivOrderDt,
            }).then((result) => {
                let data = result.data;
                let getData = [];
                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < selectedRowData2.length; j++) {
                        if (data[i].delivNo == selectedRowData2[j].delivNo) {
                            getData.push(data[i]);
                        }
                    }
                }

                if (data.type === 'Error') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                } else {
                    for (let i = 0; i < getData.length; i++) {
                        tableData.push({
                            DelivDt: getData[i].delivDt ? Commons.DateFormating(getData[i].delivDt.toString(), 2) : '',
                            ItemNm: getData[i].itemNm,
                            DelivQty: getData[i].delivQty,
                            ItemStdAmt: getData[i].itemStdAmt,
                            ItemCost: getData[i].delivQty * getData[i].itemStdAmt,
                            ItemVat:
                                getData[i].itemVatYn === 'Y' ? getData[i].delivQty * getData[i].itemStdAmt * 0.1 : 0,
                        });
                        totalAmt.push(
                            getData[i].delivQty * getData[i].itemStdAmt +
                                (getData[i].itemVatYn === 'Y' ? getData[i].delivQty * getData[i].itemStdAmt * 0.1 : 0)
                        );
                    }

                    for (let i = 0; i < totalAmt.length; i++) {
                        sumAmt += totalAmt[i];
                    }
                    headerData.push({
                        ReportTitle: '거래명세서',
                        CustNm: getData[0].custNm,
                        SerialNo: getData[0].serialNm ? Commons.DateFormating(getData[0].serialNm.toString(), 4) : '',
                        TotalAmt: sumAmt,
                        TotalAmtKr: convertToKoreanNumber(sumAmt),
                        CustTel: getData[0].custTel,
                        BusinessNo: getData[0].businessNo,
                        PersonCharg: getData[0].personCharg,
                        CustShortNm: getData[0].custShortNm,
                        Address: getData[0].address,
                    });
                    var f = document.createElement('form');
                    f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
                    f.method = 'POST';
                    f.target = '_blank';

                    var k = document.createElement('input');
                    k.type = 'hidden';
                    k.name = 'headerData';
                    k.value = JSON.stringify(headerData);
                    f.append(k);
                    var l = document.createElement('input');
                    l.type = 'hidden';
                    l.name = 'tableData';
                    l.value = JSON.stringify(tableData);
                    f.append(l);
                    document.body.appendChild(f);

                    f.submit();
                }
            });
        }
    };
    //인쇄1
    const Print1 = async (_delivOrderNo, _delivOrderDt) => {
        let headerData = [];
        let tableData = [];
        let address;
        let purchaseDtlData = [];
        let totalAmt = [];
        let sumAmt = 0;
        //var ItemInfo = itemList.find(f => f.ItemCd == viewModel.DataItem.ItemCd);

        //address = "http://localhost:65061/SalesManagement/SalesManagementRemark"; //http://localhost:65061/ 114.206.84.134:5540
        address = 'https://dongsungprintingmes.com:8082/SalesManagement/SalesManagementRemark'; //http://localhost:65061/ 114.206.84.134:5540 https://dongsungprintingmes.com:8082

        if (rowData2.length === 0) {
            setSnackbars({
                toggle: true,
                type: 'info',
                message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0].lanName,
            });
        } else {
            await Commons.Axios('get', Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.GetPrintData, {
                delivOrderNo: selectedRowData[0].delivOrderNo,
                delivOrderDt: selectedRowData[0].delivOrderDt,
            }).then((result) => {
                let data = result.data;
                let getData = [];
                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < selectedRowData2.length; j++) {
                        if (data[i].delivNo == selectedRowData2[j].delivNo) {
                            getData.push(data[i]);
                        }
                    }
                }
                if (data === '데이터가 없습니다.') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                } else if (data.type === 'Error') {
                    setSnackbars({
                        toggle: true,
                        type: 'info',
                        message: lanData.filter((f) => f.lanId === 'Snack_NullData' && f.lanType === 'SNACK')[0]
                            .lanName,
                    });
                } else {
                    for (let i = 0; i < getData.length; i++) {
                        tableData.push({
                            DelivDt: getData[i].delivDt ? Commons.DateFormating(getData[i].delivDt.toString(), 2) : '',
                            ItemNm: getData[i].itemNm,
                            DelivQty: getData[i].delivQty,
                            ItemStdAmt: getData[i].itemStdAmt,
                            ItemCost: getData[i].delivQty * getData[i].itemStdAmt,
                            ItemVat:
                                getData[i].itemVatYn === 'Y' ? getData[i].delivQty * getData[i].itemStdAmt * 0.1 : 0,
                            WriteNote: getData[i].remark, //적요
                        });
                        totalAmt.push(
                            getData[i].delivQty * getData[i].itemStdAmt +
                                (getData[i].itemVatYn === 'Y' ? getData[i].delivQty * getData[i].itemStdAmt * 0.1 : 0)
                        );
                    }
                    for (let i = 0; i < totalAmt.length; i++) {
                        sumAmt += totalAmt[i];
                    }
                    headerData.push({
                        ReportTitle: '거래명세서',
                        CustNm: getData[0].custNm,
                        SerialNo: getData[0].serialNm ? Commons.DateFormating(getData[0].serialNm.toString(), 2) : '',
                        TotalAmt: sumAmt,
                        TotalAmtKr: convertToKoreanNumber(sumAmt),
                        CustTel: getData[0].custTel,
                        BusinessNo: getData[0].businessNo,
                        PersonCharg:
                            getData[0].personCharg == null ||
                            getData[0].personCharg == undefined ||
                            getData[0].personCharg == ''
                                ? null
                                : getData[0].personCharg,
                        CustShortNm: getData[0].custShortNm,
                        Address: getData[0].address,
                        AddItem: getData[0].addItem, //추가항목
                    });
                    var f = document.createElement('form');
                    f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
                    f.method = 'POST';
                    f.target = '_blank';

                    var k = document.createElement('input');
                    k.type = 'hidden';
                    k.name = 'headerData';
                    k.value = JSON.stringify(headerData);
                    f.append(k);
                    var l = document.createElement('input');
                    l.type = 'hidden';
                    l.name = 'tableData';
                    l.value = JSON.stringify(tableData);
                    f.append(l);
                    document.body.appendChild(f);

                    f.submit();
                }
            });
        }
    };
    //오른쪽 그리드 저장 (비고)
    const SaveConfirm = (_type) => {
        Dialog.Confirm(
            lanData.filter((f) => f.lanId === 'Dia_Title_Save' && f.lanType === 'DIALOG')[0].lanName,
            lanData.filter((f) => f.lanId === 'Dia_Message_Save' && f.lanType === 'DIALOG')[0].lanName,
            lanData.filter((f) => f.lanId === 'Dia_Btn_Confirm' && f.lanType === 'DIALOG')[0].lanName,
            () => {
                SaveLogic();
            }
        );
    };
    //오른쪽 그리드 저장 (비고)
    const SaveLogic = async () => {
        Dialog.ProgressBar(true);
        let userInfo = null;
        let getData = [];
        try {
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            for (let i = 0; i < rowData2.length; i++) {
                getData.push({
                    delivNo: rowData2[i].delivNo,
                    remark: rowData2[i].remark,
                    updateId: userInfo.userId,
                });
            }
            await Commons.Axios(
                'post',
                Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.CreateDelivRemark,
                getData
            ).then((result) => {
                let data = result.data;
                if (data !== 'Ok') {
                    setSnackbars({
                        toggle: true,
                        typ: 'error',
                        message: data,
                    });
                } else {
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Save' && f.lanType === 'SNACK')[0].lanName,
                    });
                    GetDelivOrderItems(selectedRowData[0].delivOrderNo);
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    //왼쪽 그리드 삭제
    const DeleteConfirm = () => {
        Dialog.Confirm(
            lanData.filter((f) => f.lanId === 'Dia_Title_Delete' && f.lanType === 'DIALOG')[0].lanName,
            lanData.filter((f) => f.lanId === 'Dia_Message_Delete' && f.lanType === 'DIALOG')[0].lanName,
            lanData.filter((f) => f.lanId === 'Dia_Btn_Confirm' && f.lanType === 'DIALOG')[0].lanName,
            () => {
                DeleteLogic();
            }
        );
    };
    //왼쪽 그리드 삭제
    const DeleteLogic = async () => {
        Dialog.ProgressBar(true);
        let userInfo = {};
        let deleteData = [];
        try {
            await IndexedDb.GetLoginInfo().then((result) => {
                userInfo = result;
            });
            if (selectedRowData[0].stusNm == '출하') {
                setSnackbars({
                    toggle: true,
                    type: 'info',
                    message: lanData.filter(
                        (f) => f.lanId === 'Snack_AlreadyOut' && f.lanType === 'SNACK' //이미 출하되었습니다.
                    )[0].lanName,
                });
                return false;
            } else if (rowData2.length > 0) {
                setSnackbars({
                    toggle: true,
                    type: 'info',
                    message: '출하취소 후 삭제하세요.',
                });
                return false;
            }
            deleteData.push({
                delivOrderNo: selectedRowData[0].delivOrderNo,
                itemCd: selectedRowData[0].itemCd,
                soDueDt: Commons.DateStrChange(selectedRowData[0].soDueDt),
                soNo: selectedRowData[0].soNo,
            });
            console.log(deleteData);
            await Commons.Axios(
                'post',
                Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.DeleteSaleDeliv,
                deleteData
            ).then((result) => {
                let data = result.data;
                if (data !== 'Ok') {
                    setSnackbars({
                        toggle: true,
                        type: 'error',
                        message: data,
                    });
                } else {
                    setRowData2([]);
                    setSnackbars({
                        toggle: true,
                        type: 'success',
                        message: lanData.filter((f) => f.lanId === 'Snack_Delete' && f.lanType === 'SNACK')[0].lanName,
                    });
                    Init();
                    setRowData([]);
                }
            });
        } catch (e) {
            setSnackbars({
                toggle: true,
                type: 'error',
                message: e.message,
            });
        } finally {
            Dialog.ProgressBar(false);
        }
    };
    return (
        <>
            <Sm10040View
                Init={Init}
                inputs={inputs}
                setInputs={setInputs}
                rowData={rowData}
                setRowData={setRowData}
                rowData1={rowData1}
                setRowData1={setRowData1}
                rowData2={rowData2}
                setRowData2={setRowData2}
                orderData={orderData}
                setOrderData={setOrderData}
                SaveConfirm={SaveConfirm}
                stockData={stockData}
                setStockData={setStockData}
                selectedRowData={selectedRowData}
                selectedRowData2={selectedRowData2}
                setSelectedRowData={setSelectedRowData}
                selectedRowData1={selectedRowData1}
                setSelectedRowData1={setSelectedRowData1}
                setSelectedRowData2={setSelectedRowData2}
                selectedModalData={selectedModalData}
                setSelectedModalData={setSelectedModalData}
                selectedModalData1={selectedModalData1}
                setSelectedModalData1={setSelectedModalData1}
                setSelectedModalData2={setSelectedModalData2}
                GetDelivOrderItems={GetDelivOrderItems}
                CancleDelivModal={CancleDelivModal}
                GetOrders={GetOrders}
                ItemTied={ItemTied}
                CreateDelivOrder={CreateDelivOrder}
                DeleteConfirm={DeleteConfirm}
                GetStockList={GetStockList}
                CreateDeliv={CreateDeliv}
                CancleDeliv={CancleDeliv}
                setCheckInputs={setCheckInputs}
                checkInputs={checkInputs}
                paramsInputs={paramsInputs}
                setParamsInputs={setParamsInputs}
                Print={Print}
                Print1={Print1}
                lanData={lanData}
                cancleStockData={cancleStockData}
                setCancleStockData={setCancleStockData}
                setSnackbars={setSnackbars}
            />
            {snackbars.toggle && <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />}
        </>
    );
}

export default SM10040;
